import { CARD_GROUP_DROPPABLE_TYPE } from '../constants';

export const createCardGroupDroppableId = (parentId: number, cardListId: string) =>
	`${CARD_GROUP_DROPPABLE_TYPE}::${parentId}::${cardListId}`;

export const parseCardGroupDroppableId = (droppableId: string) => {
	const [prefix, parentId, cardListId] = droppableId.split('::');

	if (prefix === CARD_GROUP_DROPPABLE_TYPE && parentId && cardListId) {
		return {
			parentId: Number(parentId),
			cardListId,
		};
	}

	return null;
};
